<template>
  <b-modal
    id="modal-survey-result"
    modal-class="survey-modal google-form-modal"
    title="Phiếu thông tin"
    centered
    hide-footer
    :size="sections.length > 0 ? 'xl' : 'l'"
    @hidden="resetModal"
    @shown="openOnShow"
  >
    <div class="" :class="sections.length > 0 ? 'row mx-40' : ''">
      <div
        class=""
        :class="sections.length > 0 ? 'col-8 d-flex' : 'mb-4'"
        v-if="patientInfo"
      >
        <div class="d-flex flex-wrap">
          <div class="w-100">
            <p class="m-0">
              Họ và tên:
              <span class="patient-info">{{ patientInfo.fullName }}</span>
            </p>
          </div>

          <div class="w-100" v-if="sections.length > 0">
            <p class="m-0">
              Tuổi: <span class="patient-info">{{ patientInfo.age }}</span>
            </p>
          </div>

          <div class="w-100" v-if="sections.length > 0">
            <p class="m-0">
              Phân loại bệnh:
              <span class="patient-info">{{ diseaseType }}</span>
            </p>
          </div>

          <div class="w-100" v-if="sections.length > 0">
            <p class="m-0">
              Gói đăng ký:
              <span class="patient-info">{{
                patientInfo?.ownPackage?.name || 'Chưa có gói'
              }}</span>
            </p>
          </div>
        </div>

        <div class="d-flex flex-column gap-2" v-if="sections.length > 0">
          <div class="mb-2">
            <p class="m-0">
              Số câu hỏi:
              <span class="patient-info patient-info">
                {{ answeredCount }}/{{ totalQuestions }}
                <span v-if="totalQuestions > 0" class="text-success small">
                  ({{ completionPercentage }}%)
                </span>
              </span>
            </p>
          </div>

          <div>
            <p class="m-0 font-weight-bold">Ghi chú:</p>
            <div class="d-flex flex-wrap gap-2 mt-1">
              <span class="w-100">🔴 Chưa trả lời</span>
              <span class="w-100">🟡 Chưa hoàn thành </span>
              <span class="w-100">🟢 Hoàn thành</span>
              <span class="w-100">⚪ Chưa có câu hỏi </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class=""
        :class="sections.length > 0 ? 'col-4' : 'd-flex align-items-center'"
      >
        <label class="mr-4">Chọn khảo sát:</label>
        <basic-select
          placeholder="Chọn khảo sát"
          name="survey"
          :solid="false"
          value-label="text"
          track-by="value"
          :options="surveyOptions"
          :value.sync="surveyId"
          v-model="selectedSurveyId"
          :disabled="loading"
          class="google-select fs-18 m-0"
          :class="sections.length > 0 ? '' : 'flex-1 w-75'"
        />
      </div>
    </div>
    <div class="survey-result google-form-container" v-if="sections.length > 0">
      <div class="w-100">
        <b-overlay :show="loading">
          <template v-for="section in sections">
            <CollapseQuestionSection
              :key="section.id"
              :id="section.id"
              :section="section"
              :patientInfo="patientInfo"
            />
          </template>
        </b-overlay>
      </div>
    </div>
    <div class="w-100 text-right" v-if="sections.length > 0">
      <b-button
        class="btn-save"
        variant="success"
        @click="closeModal"
        :disabled="loading"
      >
        Lưu
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalSurveyResult',
  components: {
    CollapseQuestionSection: () => import('./CollapseQuestionSection.vue'),
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    data: {
      type: Array,
      default: () => [],
    },
    targetItem: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      sections: [],
      diseaseType: null,
      loading: false,
      surveyOptions: [],
      selectedSurveyId: null,
      patientId: null,
      accountId: null,
      ownPackage: null,
      patientInfo: null,
    };
  },
  computed: {
    totalQuestions() {
      if (!this.sections || this.sections.length === 0) return 0;
      return this.sections.reduce((total, section) => {
        return total + (section.questions ? section.questions.length : 0);
      }, 0);
    },

    answeredCount() {
      if (!this.sections || this.sections.length === 0) return 0;

      let count = 0;
      this.sections.forEach((section) => {
        if (section.questions) {
          section.questions.forEach((question) => {
            if (!question.result || question.result.length === 0) return;

            const firstResult = question.result[0];

            if (question.type === 1) {
              if (firstResult.surveyAnswerId != null) count++;
            } else if (question.type === 2) {
              if (question.result.some((r) => r.surveyAnswerId != null))
                count++;
            } else if (question.type === 3) {
              if (
                firstResult.content &&
                firstResult.content.toString().trim() !== ''
              )
                count++;
            }
          });
        }
      });

      return count;
    },

    completionPercentage() {
      if (this.totalQuestions === 0) return 0;
      return Math.round((this.answeredCount / this.totalQuestions) * 100);
    },
  },
  watch: {
    selectedSurveyId(newId) {
      if (newId) {
        this.getSurvey(newId);
      } else {
        this.sections = [];
      }
    },
    targetItem: {
      handler(newItem) {
        if (newItem) {
          this.diseaseType = newItem.diseaseType || null;
          this.patientId = newItem.patientId || null;
          this.accountId = newItem.accountId || null;
          this.ownPackage = newItem.ownPackage || null;
        }
      },
      deep: true,
    },
  },

  methods: {
    openOnShow() {
      this.getPatientInfor();
      this.getSurveyList();
    },
    resetModal() {
      this.sections = [];
      this.surveyId = null;
      this.surveyOptions = [];
      this.selectedSurveyId = null;
    },
    closeModal() {
      this.resetModal();
      this.$bvModal.hide('modal-survey-result');
    },

    async getPatientInfor() {
      try {
        this.loading = true;
        const { meta, data, error } = await this.$api.get(
          `/Patient/${this.patientId}`,
        );
        if (!meta.success) {
          return this.showToastrMessage(error.message, 'error');
        }
        this.patientInfo = data;
      } catch (error) {
        this.showToastrMessage(error.message, 'error');
      } finally {
        this.loading = false;
      }
    },
    async getSurveyList() {
      try {
        this.loading = true;
        const { meta, data, error } = await this.$api.get(
          '/Survey?page=1&size=1000&isCoach=true',
        );
        this.surveyOptions = data.map((item) => ({
          text: item.name,
          value: item.id,
        }));
        if (!meta.success) {
          return this.showToastrMessage(error.message, 'error');
        }
      } catch (error) {
        this.showToastrMessage(error.message, 'error');
      } finally {
        this.loading = false;
      }
    },
    async getSurvey(id) {
      try {
        this.loading = true;

        const { meta, data, error } = await this.$api.get(
          `/UserDashboard/Survey-detail`,
          {
            params: {
              patientId: this.patientId,
              surveyId: id,
            },
          },
        );
        if (!meta.success) {
          return this.showToastrMessage(error.message, 'error');
        }
        this.sections = data.sections;
      } catch (error) {
        this.showToastrMessage(error.message, 'error');
      } finally {
        this.loading = false;
      }
    },
    showToastrMessage(message, type) {
      if (type === 'error') {
        return this.$toastr.e({
          title: 'Lỗi',
          msg: message,
        });
      }

      return this.$toastr.s({
        title: 'Thành công',
        msg: message,
      });
    },
    async submitSurveyActivity() {
      try {
        this.loading = true;
        let payload = {
          patientId: this.patientId,
          accountId: this.accountId,
          name: this.form.name,
          appointmentDate: Math.floor((Date.now() + 7 * 3600 * 1000) / 1000),
        };

        const { meta, error } = await this.$api.post(
          '/UserDashboard/Target-Survey',
          payload,
        );

        if (!meta.success) {
          return this.showToastrMessage(error.message, 'error');
        }

        this.showToastrMessage('Thêm hoạt động mới thành công', 'success');

        this.onClickCancleBtn();
      } catch (error) {
        this.showToastrMessage(error.message, 'error');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.google-form-modal .modal-dialog {
  max-width: 900px;
}

.google-form-container {
  background: white;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.modal-title {
  font-family: 'Roboto', sans-serif;
  color: #202124;
  font-size: 1.5rem;
  font-weight: 500;
}

.google-select {
  font-family: 'Roboto', sans-serif;
}
.patient-info {
  font-size: 1.125rem;
  font-weight: 600;
}

.btn-save {
  margin: 8px 125px 0px 0px;
}
</style>
